import React from 'react';
import UserForm from '../../components/UserForm';
import { useMutation } from '@tanstack/react-query';
import api from '../../api';
import message from '~/utils/message';
import { useNavigate } from 'react-router-dom';
import Wrapper from '~/App/components/Wrapper';
import Header from '~/App/components/Header';

const CreateUser = () => {
  const navigate = useNavigate();
  const { isPending, mutate } = useMutation({
    mutationFn: api.createUser,
    retry: false,
    onSuccess: () => {
      message.success('Successfully create user');
      navigate('..');
    },
    onError: () => {
      message.error('Fail to create user');
    },
  });

  return (
    <Wrapper className="max-w-[800px]">
      <Header title="Create User" />
      <UserForm loading={isPending} onSubmit={mutate} />
    </Wrapper>
  );
};

export default CreateUser;
